module.exports = __webpack_public_path__ + "static/media/edu-job.a563961c.svg";